import { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import "./Dashboard.css";
import logo1 from "./assets/logo1.png";
import maleImg from "./assets/profile.png";
import femaleImg from "./assets/girl.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import apiClient from "./utils/apiClient";
import {
  faBars,
  faGavel,
  faLink,
  faClipboardList,
  faLaptop,
  faCalendarCheck,
  faHome,
  faBuilding,
  faUsers,
  faBullhorn,
  faClock,
  faFileExport,
  faGraduationCap,
  faCog,
  faSignOutAlt,
  faChevronDown,
  faChevronRight,
  faTachometerAlt,
  faHistory,
  faUserShield,
  faShieldAlt,
  faIdBadge,
  faUmbrellaBeach,
  faUserTie,
  faFileInvoiceDollar,
  faUserFriends,
} from "@fortawesome/free-solid-svg-icons";
import { getToken, getName, getRole,} from "./utils/cryptoUtils";

const Dashboard = () => {
  const [expanded, setExpanded] = useState({
    organization: false,
    leave: false,
    manageraccess: false,
  });
  const [showDropdown, setShowDropdown] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [gender, setGender] = useState(null);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 1024px)").matches
      : true
  );
  const isSidebarOpen = isDesktop || mobileOpen;

  const navigate = useNavigate();
  const location = useLocation();

  const userEmail = getName() || "";
  // const storedRole = (getDecryptedItem("role") || "").toLowerCase();
  const storedRole = getRole();
  const token = getToken();
  

  // Redirect if token is invalid
  useEffect(() => {
    if (!token || token.trim() === "") {
      navigate("/", { replace: true });
    }
  }, [navigate, token]);

  const toggleExpand = (menu) =>
    setExpanded((p) => ({ ...p, [menu]: !p[menu] }));

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("email");
    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  const toggleSidebar = () => setMobileOpen((v) => !v);
  const closeSidebarOnMobile = () => setMobileOpen(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const close = (e) => {
      if (
        !e.target.closest(".user-profile") &&
        !e.target.closest(".dropdown-menu")
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  // Handle sidebar on resize
  useEffect(() => {
    const mql = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => setIsDesktop(e.matches);
    mql.addEventListener("change", onChange);
    setIsDesktop(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    if (!isDesktop) setMobileOpen(false);
  }, [isDesktop]);

  useEffect(() => {
  if (!token || gender) return;

  const fetchGender = async () => {
    try {
      const data = await apiClient("/auth/user-info/");
      setGender(data?.gender);
    } catch (err) {
      console.error("Failed to fetch gender", err);
    }
  };

  fetchGender();
}, [token, gender]);


const getProfileImage = () => {
  const g = gender?.trim().toLowerCase();
  return g === "female" || g === "f" ? femaleImg : maleImg;
};


  return (
    <div className="layout-root">
      {/* Header */}
      <header className="top-bar">
        <div className="top-bar-left">
          <button
            className="menu-btn"
            aria-label="Open sidebar"
            onClick={toggleSidebar}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>

          <img src={logo1} alt="Logo" className="logo" />
          <div className="Company-name">
            <p>Sparecode Consulting LLP</p>
          </div>
        </div>

        {/* User Profile */}
        <div
          className="user-profile"
          onClick={() => setShowDropdown((s) => !s)}
        >
          <img src={getProfileImage()} alt="User" className="user-avatar" />
          <span className="user-name">{userEmail || "Guest"}</span>
          <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
          {showDropdown && (
            <div className="dropdown-menu">
              <div className="profile-header">
                <img src={getProfileImage()} alt="Avatar" className="avatar-large" />
                <div>
                  <div className="username">{userEmail}</div>
                  <div className="role">{storedRole?.toUpperCase()}</div>
                </div>
              </div>
              <Link
                to="/dashboard/Setting/profilepage"
                className="dropdown-item"
              >
                My Profile
              </Link>
              <Link
                to="/dashboard/Setting/resetpassword"
                className="dropdown-item"
              >
                Change Password
              </Link>
              <div className="dropdown-item logout" onClick={handleLogout}>
                Logout
              </div>
            </div>
          )}
        </div>
      </header>

      {/* Sidebar */}
      <nav className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <ul>
          <li>
            <Link
              to="/dashboard/home/overview"
              className={
                location.pathname === "/dashboard/home/overview"
                  ? "active"
                  : ""
              }
              onClick={closeSidebarOnMobile}
            >
              <FontAwesomeIcon icon={faLink} className="icon" />
              <span className="menu-text">Quick Links</span>
            </Link>
          </li>

          <li>
            <Link
              to="/dashboard/home/dashboard"
              className={
                location.pathname === "/dashboard/home/dashboard"
                  ? "active"
                  : ""
              }
              onClick={closeSidebarOnMobile}
            >
              <FontAwesomeIcon icon={faTachometerAlt} className="icon" />
              <span className="menu-text">Dashboard</span>
            </Link>
          </li>

          {/* Organization */}
          <li>
            <div
              className={`menu-item ${expanded.organization ? "active" : ""}`}
              onClick={() => toggleExpand("organization")}
            >
              <FontAwesomeIcon icon={faBuilding} className="icon" />
              <span className="menu-text">Organization</span>
              <FontAwesomeIcon
                icon={expanded.organization ? faChevronDown : faChevronRight}
                className="expand-icon"
              />
            </div>
            {expanded.organization && (
              <ul className="submenu">
                <li>
                  <Link
                    to="organization/hrdetail"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faIdBadge} className="icon" />
                    <span className="menu-text">HR Details</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="organization/policypage"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faShieldAlt} className="icon" />
                    <span className="menu-text">Policy</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="organization/holidays"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faUmbrellaBeach} className="icon" />
                    <span className="menu-text">Holiday</span>
                  </Link>
                </li>
                <li>
                  <a
                    href="/posh-training-v2.html"
                    onClick={closeSidebarOnMobile}
                    target="_blank"   // optional (open in new tab)
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faGavel} className="icon" />
                    <span className="menu-text">POSH Training</span>
                  </a>
                </li>
                <li>
                  <Link
                    to="organization/referal"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faUserFriends} className="icon" />
                    <span className="menu-text">Referal</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>

          {/* Teams */}
          <li>
            <Link to="team/employeelist" onClick={closeSidebarOnMobile}>
              <FontAwesomeIcon icon={faUsers} className="icon" />
              <span className="menu-text">Teams</span>
            </Link>
          </li>

          {/* Announcements */}
          <li>
            <Link to="/dashboard/announcements" onClick={closeSidebarOnMobile}>
              <FontAwesomeIcon icon={faBullhorn} className="icon" />
              <span className="menu-text">Announcements</span>
            </Link>
          </li>

          {/* Roster */}
          <li>
            <Link to="page/rosterviewpage" onClick={closeSidebarOnMobile}>
              <FontAwesomeIcon icon={faClock} className="icon" />
              <span className="menu-text">Roster</span>
            </Link>
          </li>

          {/* Salary */}
          <li>
            <Link to="Salary/salaryslippage" onClick={closeSidebarOnMobile}>
              <FontAwesomeIcon icon={faFileInvoiceDollar} className="icon" />
              <span className="menu-text">Salary Slip Request</span>
            </Link>
          </li>

          {/* Resignation */}
          <li>
            <Link
              to="/dashboard/resignation/applyresignationform"
              onClick={closeSidebarOnMobile}
            >
              <FontAwesomeIcon icon={faSignOutAlt} className="icon" />
              <span className="menu-text">Apply Resignation</span>
            </Link>
          </li>

          {/* Leave */}
          <li>
            <div
              className={`menu-item ${expanded.leave ? "active" : ""}`}
              onClick={() => toggleExpand("leave")}
            >
              <FontAwesomeIcon icon={faUmbrellaBeach} className="icon" />
              <span className="menu-text">Leave</span>
              <FontAwesomeIcon
                icon={expanded.leave ? faChevronDown : faChevronRight}
                className="expand-icon"
              />
            </div>
            {expanded.leave && (
              <ul className="submenu">
                <li>
                  <Link to="leave/applyleave" onClick={closeSidebarOnMobile}>
                    <FontAwesomeIcon icon={faCalendarCheck} className="icon" />
                    <span className="menu-text">Apply Leave</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="leave/ApplyWorkFromHome"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faHome} className="icon" />
                    <span className="menu-text">WFH Request</span>
                  </Link>
                </li>
                <li>
                  <Link to="leave/empCarryForwardLeave" onClick={closeSidebarOnMobile}>
                    <FontAwesomeIcon icon={faCalendarCheck} className="icon" />
                    <span className="menu-text">Carry Forward Leave</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="leave/empleavehistory"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faHistory} className="icon" />
                    <span className="menu-text">Leave History</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="leave/leavesummary"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faHistory} className="icon" />
                    <span className="menu-text">Leave Summary</span>
                  </Link>
                </li>
                <li>
                  <Link
                    to="leave/wfhhistory"
                    onClick={closeSidebarOnMobile}
                  >
                    <FontAwesomeIcon icon={faUserTie} className="icon" />
                    <span className="menu-text">WFH History</span>
                  </Link>
                </li>
              </ul>
            )}
          </li>


          {/* Manager Access
          {storedRole === "manager" && (
            <li>
              <div
                className="menu-item"
                onClick={() => toggleExpand("manageraccess")}
              >
                <FontAwesomeIcon icon={faCog} className="icon" />
                <span className="menu-text">Manager Access</span>
                <FontAwesomeIcon
                  icon={expanded.manageraccess ? faChevronDown : faChevronRight}
                  className="expand-icon"
                />
              </div>
              {expanded.manageraccess && (
                <ul className="submenu">
                  <li>
                    <Link
                      to="Feedback/FeedbackPage"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon icon={faGraduationCap} className="icon" />
                      <span className="menu-text">Dashboard</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )} */}


          {/* Asset HRMS */}
          {(storedRole?.toLowerCase() === "admin" ||
            storedRole?.toLowerCase() === "manager") && (
            <li>
              <div
                className={`menu-item ${
                  expanded.assethrms ? "active" : ""
                }`}
                onClick={() => toggleExpand("assethrms")}
              >
                <FontAwesomeIcon
                  icon={faLaptop}
                  className="icon"
                />

                <span className="menu-text">
                  Asset HRMS
                </span>

                <FontAwesomeIcon
                  icon={
                    expanded.assethrms
                      ? faChevronDown
                      : faChevronRight
                  }
                  className="expand-icon"
                />
              </div>

              {expanded.assethrms && (
                <ul className="submenu">

                  <li>
                    <Link
                      to="/dashboard/ManagerAcess/assetdashboard"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faTachometerAlt}
                        className="icon"
                      />
                      <span className="menu-text">
                        Dashboard
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/dashboard/ManagerAcess/assetassignments"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faClipboardList}
                        className="icon"
                      />
                      <span className="menu-text">
                        Assets
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/dashboard/ManagerAcess/employeeassetprofile"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faUsers}
                        className="icon"
                      />
                      <span className="menu-text">
                        Employee Profile
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/dashboard/ManagerAcess/reportsexports"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faFileExport}
                        className="icon"
                      />
                      <span className="menu-text">
                        Reports
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/dashboard/ManagerAcess/assetprofile"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faHistory}
                        className="icon"
                      />
                      <span className="menu-text">
                        Asset Profile
                      </span>
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to="/dashboard/ManagerAcess/newasset"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faHistory}
                        className="icon"
                      />
                      <span className="menu-text">
                         Add New Asset
                      </span>
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/dashboard/ManagerAcess/assetinventorylist"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon
                        icon={faHistory}
                        className="icon"
                      />
                      <span className="menu-text">
                         Asset Inventory
                      </span>
                    </Link>
                  </li>

                </ul>
              )}
            </li>
          )}

          {/* Manager Access */}
          {storedRole === "manager" && (
            <li>
              <div
                className="menu-item"
                onClick={() => toggleExpand("manageraccess")}
              >
                <FontAwesomeIcon icon={faCog} className="icon" />
                <span className="menu-text">Manager Access</span>
                <FontAwesomeIcon
                  icon={expanded.manageraccess ? faChevronDown : faChevronRight}
                  className="expand-icon"
                />
              </div>
              {expanded.manageraccess && (
                <ul className="submenu">
                  <li>
                    <Link
                      to="Feedback/FeedbackPage"
                      onClick={closeSidebarOnMobile}
                    >
                      <FontAwesomeIcon icon={faGraduationCap} className="icon" />
                      <span className="menu-text">Dashboard</span>
                    </Link>
                  </li>
                </ul>
              )}
            </li>
          )}

          {/* Admin Access */}
          {storedRole === "admin" && (
            <li>
              <Link to="admin/admindashboard" onClick={closeSidebarOnMobile}>
                <FontAwesomeIcon icon={faUserShield} className="icon" />
                <span className="menu-text">Admin Access</span>
              </Link>
            </li>
          )}
        </ul>
      </nav>

      {/* Backdrop (mobile) */}
      {!isDesktop && isSidebarOpen && (
        <div className="backdrop" onClick={closeSidebarOnMobile} />
      )}

      {/* Main content */}
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default Dashboard;
